<template>
  <div>
    <navbar
      ref="navbar"
      @allContentStyle="routerTo('all')"
      @HKContentStyle="routerTo('hongkong')"
      @nonHKContentStyle="routerTo('nonhongkong')"
      @urbtixContentStyle="routerTo('urbtix')"
      @uatContentStyle="routerTo('online')"
    ></navbar>
    <main-box></main-box>
    <footerContent class="footerContent"></footerContent>
  </div>
</template>

<script>
import navbar from '@/components/navbar'
import mainBox from './mainBox'
import footerContent from '@/components/footerContent'

export default {
  name: 'Tnc',
  components: {
    navbar,
    mainBox,
    footerContent
  },
  methods: {
    // navbar路由跳转
    routerTo (ft) {
      window.location.href = `${this.$cwLink}/Events.html?ft=${ft}&lang=${this.$i18n.locale}`
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .footer .social-bar{
  display: none;
}

::v-deep .cw-main_navbar {
  margin-bottom: 0;
}

@media (max-width: 991px) {
  .footerContent {
    display: none;
  }
}
</style>
